/**
 * Particle shape multi mode value.
 */
export enum ParticleShapeArcMode {
  /** Generate points randomly. */
  Random,
  /** Animate the emission point around the shape. */
  Loop
}
